
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useContext, useState } from 'react';
import { Box, MenuItem, Select, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import numeral from 'numeral';

const EditableBelongings = () => {
	const { defaultQuery, setInitialPayloadData, initialPayload } = useContext(FormDataContext);
	const [isEditing, setIsEditing] = useState(false);
	const belongingsChosen = initialPayload?.coverage.parameters.find(
		(item) => item.name === 'personalPropertyAmount'
	)

	const propertyValues = React.useMemo(() => {
		const defaultData = { min: 5000, max: 95000, step: 5000 };
		if (!defaultQuery) return defaultData;

		return defaultQuery.coveragesCue.parameters.reduce<Record<'min' | 'max' | 'step', number>>(
			(accum, item) => {
				if (item.name === 'personalPropertyMin' && typeof item.value === 'string') {
					accum['min'] = Number(item.value);
				} else if (item.name === 'personalPropertyMax' && typeof item.value === 'string') {
					accum['max'] = Number(item.value);
				} else if (item.name === 'personalPropertyIncrement' && typeof item.value === 'string') {
					accum['step'] = Number(item.value);
				}
				return accum;
			},
			defaultData
		);
	}, [defaultQuery]);

	const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));

	const generateOptions = () => {
		const options: number[] = [];
		for (let i = propertyValues.min; i <= propertyValues.max; i += propertyValues.step) {
			options.push(i);
		}
		return options;
	};

	const options = generateOptions();
	const rawValue = Number(belongingsChosen?.value);
	const clampedValue = Number.isFinite(rawValue)
		? clamp(rawValue, propertyValues.min, propertyValues.max)
		: propertyValues.min;

	const currentValue = clampedValue.toString();

	const handleEdit = () => {
		setIsEditing(true);
	};

	const handleChange = (event: { target: { value: string | number } }) => {
		const newValue = event.target.value;
		setInitialPayloadData((prevState) => {
			if (!prevState) return prevState;
			const newParametersData = prevState.coverage.parameters.map((item) => {
				if (item.name === 'personalPropertyAmount') {
					return { ...item, value: newValue };
				}
				return item;
			});
			return {
				...prevState,
				coverage: {
					parameters: newParametersData,
				},
			};
		});
		setIsEditing(false);
	};

	if (isEditing) {
		return (
			<Select
				value={currentValue}
				onChange={handleChange}
				onBlur={() => setIsEditing(false)}
				autoFocus
				size="small"
				sx={{ fontWeight: 700 }}
			>
				{options.map((option) => (
					<MenuItem key={option} value={option.toString()}>
						{numeral(option).format('$0,0[.]00')}
					</MenuItem>
				))}
			</Select>
		);
	}

	return (
		<Box
			display="flex"
			alignItems="center"
			gap={1}
			onClick={handleEdit}
			sx={{ cursor: 'pointer' }}
		>
			<EditIcon fontSize="inherit" />
			<Typography fontWeight={700} textAlign="right">
				{numeral(Number(currentValue)).format('$0,0[.]00')}
			</Typography>
		</Box>
	);
};

export default EditableBelongings;
